(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/maltipset/assets/javascripts/models/coupon.js') >= 0) return;  svs.modules.push('/modules/maltipset/assets/javascripts/models/coupon.js');

'use strict';

const {
  createWager
} = svs.components.payment.createWager;
const {
  productIds
} = svs.utils.products;
const {
  createStandardPaymentFlow
} = svs.components.wagerPaymentFlow.standardFlow;
const {
  executePayment
} = svs.components.wagerPaymentFlow.executePayment;
const {
  createSelfServicePaymentFlow
} = svs.components.wagerPaymentFlow.selfServiceFlow;
const {
  formatDate
} = svs.components.lbUtils.helpers;
svs.maltipset.models.Coupon = Backbone.Model.extend({
  preserve: true,
  preserveBindings: true,
  initialize() {
    this.set('system', svs.maltipset.models.storageCoupon.get('system') || svs.maltipset.constants.SYSTEM.NO_SYSTEM, {
      silent: true
    });
    if (svs.maltipset.models.storageCoupon.get('drawNumber') === this.get('draw').get('drawNumber')) {
      this.set('board', new svs.maltipset.collections.Board(undefined, {
        selectedMatchIndexes: svs.maltipset.models.storageCoupon.getSelectedMatchIndexes(),
        coupon: this,
        system: svs.maltipset.models.storageCoupon.get('system') || svs.maltipset.constants.SYSTEM.NO_SYSTEM,
        xpertBaseRowMode: svs.maltipset.models.storageCoupon.get('xpertBaseRowMode') || false,
        reset: false
      }), {
        silent: true
      });
      this.set('hasMarkedMatches', _.filter(svs.maltipset.models.storageCoupon.get('selectedMatches'), arr => arr.length).length > 0, {
        silent: true
      });
      this.updateSportkryss(svs.maltipset.models.storageCoupon.get('sportkryssBet'));
      this.updateNumWeeks(svs.maltipset.models.storageCoupon.get('numWeeks'));
      this.set({
        xpertBaseRowMode: svs.maltipset.models.storageCoupon.get('xpertBaseRowMode') || false,
        baseRow: svs.maltipset.models.storageCoupon.get('baseRow'),
        actionBar: svs.maltipset.models.storageCoupon.get('actionBar'),
        xpertSize: svs.maltipset.models.storageCoupon.get('xpertSize'),
        xpertSystem: svs.maltipset.models.storageCoupon.get('xpertSystem'),
        isProlonging: svs.maltipset.models.storageCoupon.get('isProlonging')
      }, {
        silent: true
      });
    } else {
      this.set('board', new svs.maltipset.collections.Board(undefined, {
        coupon: this,
        system: svs.maltipset.constants.SYSTEM.NO_SYSTEM
      }), {
        silent: true
      });
    }
    this.setInitialData(true);
    this.getAccountBalance();
    this.listenTo(this, 'change:system', this.resetCoupon, this);
    this.listenTo(this, 'change:numWeeks change:sportkryssBet', this.costChanged, this);
    this.listenTo(this, 'change:totalSelectedMatches', this.onTotalSelectedMatchesChange, this);
    this.listenTo(this.get('draw').get('matchList'), 'currentMatchSet', this.setSelectedMatch);
  },
  isBoardValid() {
    return this.get('board').getTotalCompleteRows() > 0;
  },
  setInitialData(silent) {
    const totalCompleteRows = this.get('board').getTotalCompleteRows();
    const coupon = {
      currentRow: this.get('board').first(),
      totalSelectedMatches: this.get('board').getTotalSelectedMatches(),
      totalCompleteRows,
      isValid: this.isBoardValid(),
      totalCost: this.getTotalCost(totalCompleteRows),
      numberOfSelectedMatches: this.get('board').first().get('numberOfSelectedMatches'),
      matchesLeftToSelect: this.get('board').first().getMatchesLeftToSelect(),
      matchesLeftToMaxSelect: this.get('board').first().getMatchesMaxLeftToSelect(),
      activeRowNum: 0
    };
    this.set(coupon, {
      silent: silent || false
    });
    this.listenTo(this.get('currentRow'), 'change:numberOfSelectedMatches', this.numberOfSelectedMatchesChanged, this);
  },
  getTotalCost(totalCompleteRows) {
    const sportkryssCost = this.get('hasSportkryssBet') ? this.get('sportkryssBet').rowPriceMulti * 10 : 0;
    const totalCost = (totalCompleteRows * svs.maltipset.constants.ONE_ROW_COST + sportkryssCost) * this.get('numWeeks');
    if (totalCost === 0) {
      return svs.maltipset.constants.ONE_ROW_COST;
    }
    return totalCost;
  },
  getAccountBalance() {
    const self = this;
    if (self.isEnabled()) {
      svs.components.account_balance.get(balance => {
        self.set('accountBalance', balance != null ? svs.utils.format.Currency(balance) : null);
        self.set('userAccountBalace', balance != null ? svs.utils.format.Currency(balance) : null);
      });
      svs.components.account_balance.on('change', balance => {
        self.set('accountBalance', balance != null ? svs.utils.format.Currency(balance) : null);
        self.set('userAccountBalace', balance != null ? svs.utils.format.Currency(balance) : null);
      }, this);
    }
  },
  getBoardData(getIncompleteRows) {
    return this.get('board').getBoardData(getIncompleteRows);
  },
  resetCoupon() {
    this.stopListening(this.get('currentRow'), 'change:numberOfSelectedMatches');
    svs.maltipset.models.storageCoupon.storeSelectedMatches(this.get('draw').get('drawNumber'), this.get('system'), this.getBoardData(true));
    this.setInitialData(false);
    this.get('draw').get('matchList').updateMarkedMatchesCount(this.get('board'));
  },
  stopBaseRowEdit() {
    this.get('board').resetAndInitializeRows({
      system: this.get('system')
    });
    this.removeActionbar();
    const xpertObject = {
      baseRow: undefined,
      xpertBaseRowMode: false,
      xpertSize: 0
    };
    svs.maltipset.models.storageCoupon.set(xpertObject);
    this.set(xpertObject);
    this.resetCoupon();
    this.trigger('stopBaseRowEdit');
  },
  createBaseRow() {
    this.get('board').setBoardToBaseRow();
    this.resetCoupon();
    const baseRowObject = {
      xpertBaseRowMode: true,
      actionBar: svs.maltipset.constants.ACTIONBARS.BASEROW
    };
    this.set(baseRowObject);
    svs.maltipset.models.storageCoupon.set(baseRowObject);
    this.trigger('createBaseRow');
  },
  newXpert(useBaseRow) {
    this.trigger('xpert:startLoad');
    let xpert;
    const self = this;
    if (useBaseRow) {
      xpert = new svs.maltipset.models.Xpert({
        baseRow: this.get('baseRow') || this.get('board').getBoardData(true),
        xpertSize: this.get('xpertSize'),
        system: this.get('system'),
        drawNumber: this.get('draw').get('drawNumber')
      });
    } else {
      const xpertOptions = {
        xpertSize: this.get('xpertSize'),
        system: this.get('system'),
        drawNumber: this.get('draw').get('drawNumber')
      };
      xpert = new svs.maltipset.models.Xpert(xpertOptions);
    }
    this.listenToOnce(xpert, 'error', (model, resp) => {
      self.trigger('xpert:doneLoad xpert:error', resp);
    });
    this.listenToOnce(xpert, 'sync', model => {
      self.get('board').setBoardFromXpert(model);
      const xpertObject = {
        xpertSize: model.get('xpertSize'),
        xpertBaseRowMode: false,
        actionBar: svs.maltipset.constants.ACTIONBARS.XPERT,
        xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.WEIGHTEDQP,
        isValid: true
      };
      if (useBaseRow) {
        xpertObject.baseRow = model.get('baseRow');
        xpertObject.xpertSystem = svs.maltipset.constants.XPERT_PROPERTIES.PARTIALQP;
      } else {
        xpertObject.baseRow = undefined;
      }
      self.set(xpertObject, {
        silent: true
      });
      svs.maltipset.models.storageCoupon.set(xpertObject);
      self.resetCoupon();
      self.trigger('change:isValid change:actionBar xpert:doneLoad');
      self.trigger('stopBaseRowEdit');
      self.stopListening(xpert, 'error');
    });
    xpert.fetch();
  },
  removeXpert() {
    if (this.get('xpertSystem') !== 'NOEXPERT') {
      this.removeActionbar();
    }
    const xpertObject = {
      baseRow: undefined,
      xpertSize: 0,
      xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT
    };
    this.set(xpertObject, {
      silent: true
    });
    svs.maltipset.models.storageCoupon.set(xpertObject);
    this.trigger('xpertRemoved');
  },
  changeSystem(toSystem) {
    if (this.get('xpertBaseRowMode')) {
      this.stopBaseRowEdit();
    }
    if (this.get('xpertSize')) {
      this.removeXpert();
    }
    this.get('board').convertSystem(this.get('system'), toSystem);
    const bar = toSystem !== svs.maltipset.constants.SYSTEM.NO_SYSTEM ? svs.maltipset.constants.ACTIONBARS.SYSTEM : svs.maltipset.constants.ACTIONBARS.NO_BAR;
    svs.maltipset.models.storageCoupon.set('actionBar', bar);
    this.set({
      system: toSystem,
      actionBar: bar
    }, {
      silent: true
    });
    this.trigger('change:system', toSystem);
    _.defer(() => {
      svs.components.loader.hide();
    });
  },
  removeActionbar() {
    this.set('actionBar', svs.maltipset.constants.ACTIONBARS.NO_BAR);
    svs.maltipset.models.storageCoupon.set('actionBar', svs.maltipset.constants.ACTIONBARS.NO_BAR);
  },
  canConvertToSystem(toSystem) {
    return this.get('board').canConvertSystem(this.get('system'), toSystem);
  },
  numberOfSelectedMatchesChanged(row) {
    const totalCompleteRows = this.get('board').getTotalCompleteRows();
    if (row.get('lastMatchChanged')) {
      this.get('draw').get('matchList').at(row.get('lastMatchChanged').index).markChanged(row.get('lastMatchChanged').mark);
    }
    const storeObject = {
      totalSelectedMatches: this.get('board').getTotalSelectedMatches(),
      numberOfSelectedMatches: row.get('numberOfSelectedMatches'),
      totalCompleteRows,
      isValid: this.isBoardValid(),
      totalCost: this.getTotalCost(totalCompleteRows),
      matchesLeftToSelect: row.getMatchesLeftToSelect(),
      matchesLeftToMaxSelect: row.getMatchesMaxLeftToSelect(),
      xpertSystem: this.get('xpertSize') > 0 ? svs.maltipset.constants.XPERT_PROPERTIES.MODIFIEDQP : svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT,
      baseRow: undefined,
      isProlonging: false
    };
    this.set(storeObject);
    svs.maltipset.models.storageCoupon.set(storeObject);
    if (this.get('actionBar') === svs.maltipset.constants.ACTIONBARS.XPERT) {
      this.removeActionbar();
    }
    svs.maltipset.models.storageCoupon.storeSelectedMatches(this.get('draw').get('drawNumber'), this.get('system'), this.getBoardData(true));
  },
  setSelectedRow(index) {
    this.stopListening(this.get('currentRow'), 'change:numberOfSelectedMatches');
    const currentRow = this.get('board').at(index);

    this.get('board').models.forEach(row => {
      row.set('active', false);
    });

    currentRow.set('active', true);
    this.get('board').currentRowIndex = index;
    this.set({
      currentRow,
      numberOfSelectedMatches: currentRow.get('numberOfSelectedMatches'),
      matchesLeftToSelect: currentRow.getMatchesLeftToSelect(),
      activeRowNum: index
    });
    this.listenTo(this.get('currentRow'), 'change:numberOfSelectedMatches', this.numberOfSelectedMatchesChanged, this);
  },
  clear(coupon) {
    coupon = coupon || self;
    coupon.set({
      numWeeks: 1,
      sportkryssBet: null,
      hasSportkryssBet: false,
      hasMarkedMatches: false
    });
    coupon.removeXpert();
    coupon.get('board').currentRowIndex = 0;
    coupon.empty();
    coupon.trigger('destroyBetslipAfterPayment', true);
  },
  createNewWager() {
    const draw = this.get('draw');
    const boardData = this.getBoardData();
    const system = this.get('system');
    const xpertSystem = this.get('xpertSystem');
    const productId = draw.get('productId');
    const wager = createWager().addBet(productId, bet => {
      bet.setDrawNumber(draw.get('drawNumber'));
      bet.setNumberOfDraws(this.get('numWeeks'));
      boardData.forEach(board => {
        bet.addBoard(wagerBoard => {
          if (system && system === svs.maltipset.constants.SYSTEM.R_SYSTEM) {
            wagerBoard.setSystemNumber(board.length);
          }
          if (xpertSystem && xpertSystem !== svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT) {
            wagerBoard.addBoardProperty(xpertSystem);
          }
          wagerBoard.addOutcomes(board);
        });
      });
    });
    if (this.get('hasSportkryssBet')) {
      const sportkryssBet = this.get('sportkryssBet');
      wager.addBet(productIds.SPORTKRYSS, bet => {
        bet.addBoard(wagerBoard => {
          const sportkryssBoardData = sportkryssBet.jokerBoards[0].boardData;
          sportkryssBoardData.forEach(outcome => {
            wagerBoard.addOutcomes([outcome]);
          });
        });
        bet.setRowPrice(sportkryssBet.rowPriceMulti);
        bet.setNumberOfDraws(this.get('numWeeks'));
      });
    }
    return wager;
  },
  async createAndExecutePayment(wager) {
    const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
    if (isSelfService) {
      const draw = this.get('draw');
      const regCloseTime = formatDate.formatDate(draw.get('regCloseTime'), true, true);
      const wagerCount = await createSelfServicePaymentFlow({
        wagers: [wager],
        regCloseTimes: [regCloseTime]
      });
      if (wagerCount > 0) {
        this.empty(true);
        svs.maltipset.router.navigate('', {
          trigger: true
        });
      }
    } else {
      const paymentBuilder = createStandardPaymentFlow({
        config: {
          haltPaymentOnException: true
        },
        wagers: [wager]
      });
      const [, error] = await executePayment(paymentBuilder);
      return error;
    }
  },
  async pay() {
    const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
    const wager = this.createNewWager();
    const error = await this.createAndExecutePayment(wager);
    if (!error && !isSelfService) {
      this.empty(true);
      this.removeXpert();
      this.get('board').currentRowIndex = 0;
      this.trigger('destroyBetslipAfterPayment', true);
      this.trigger('wager:paySuccess', wager);
    }
  },
  empty(clearSystem) {
    if (clearSystem) {
      this.set('system', svs.maltipset.constants.SYSTEM.NO_SYSTEM, {
        silent: true
      });
    }
    this.removeXpert();
    this.get('board').currentRowIndex = 0;
    this.trigger('coupon:empty');
    this.get('draw').get('matchList').updateMarkedMatchesCount(this.get('board'));
    this.get('draw').get('matchList').trigger('reset');
    this.set('isValid', false);
    svs.maltipset.models.storageCoupon.empty();
    this.resetCoupon();
  },
  updateNumWeeks(numWeeks) {
    this.set('numWeeks', numWeeks);
    if (this.get('hasSportkryssBet')) {
      this.get('sportkryssBet').numDraws = numWeeks;
      svs.maltipset.models.storageCoupon.set('sportkryssBet', this.get('sportkryssBet'));
    }
    svs.maltipset.models.storageCoupon.set('numWeeks', numWeeks);
  },
  updateSportkryss(sportkryssBet, forceValid) {
    let valid = this.isBoardValid();
    if (sportkryssBet) {
      sportkryssBet.numDraws = this.get('numWeeks');
    }
    if (sportkryssBet && sportkryssBet.jokerBoards && sportkryssBet.jokerBoards[0] && sportkryssBet.jokerBoards[0].boardData) {
      valid = valid && sportkryssBet.jokerBoards[0].boardData.length == svs.maltipset.constants.VALID_SPORTKRYSS_LENGTH;
    } else {
      valid = valid && true;
    }
    if (forceValid) {
      valid = true;
    }
    this.set({
      sportkryssBet,
      hasSportkryssBet: Boolean(sportkryssBet && sportkryssBet.betAmountSalesGroup1),
      isValid: valid
    });
    svs.maltipset.models.storageCoupon.set('sportkryssBet', sportkryssBet, {
      silent: true
    });
    svs.maltipset.models.storageCoupon.trigger('change', svs.maltipset.models.storageCoupon);
  },
  costChanged() {
    this.set('totalCost', this.getTotalCost(this.get('totalCompleteRows')));
  },
  isEnabled() {
    return this.get('draw').isOpen();
  },
  isMOrRSystem() {
    return this.get('system') !== svs.maltipset.constants.SYSTEM.NO_SYSTEM;
  },
  onTotalSelectedMatchesChange() {
    this.set('hasMarkedMatches', this.get('totalSelectedMatches') > 0);
  },
  prolong(enable) {
    this.set('isProlonging', enable);
    svs.maltipset.models.storageCoupon.set('isProlonging', enable);
  },
  setSelectedMatch() {
    this.set('selectedMatch', this.get('draw').get('matchList').getCurrentMatch());
  },
  setAccountBalance(balance) {
    this.set('accountBalance', balance != null ? svs.utils.format.Currency(balance) : null);
  },
  defaults() {
    return {
      numberOfSelectedMatches: 0,
      numWeeks: 1,
      system: svs.maltipset.constants.SYSTEM.NO_SYSTEM,
      hasMarkedMatches: false,
      xpertBaseRowMode: false,
      xpertSystem: svs.maltipset.constants.XPERT_PROPERTIES.NOXPERT,
      actionBar: svs.maltipset.constants.ACTIONBARS.NO_BAR,
      isProlonging: false
    };
  }
});

 })(window);